<template>
    <button id="clearFilterButton" type="button" class="btn btn-default" v-on:click="reloadPage()">
        {{$lang('Wyczyść filtry')}}
    </button>
</template>

<script>
    export default {
        name: 'reload-button',
        methods: {
            reloadPage() {
                window.location.href = window.location.href.split("?")[0];
            },
        }
    }
</script>
